import { useAppDispatch } from "../../../redux-store";
import useFeature from "../../../hooks/useFeature";
import * as connectionActions from "../../../ducks/app/connection";
import { errorToastShown } from "../../../ducks/app/error-toast";
import { handleActionError } from "../../../helpers/actionError";

/**
 * Shows a failed photo/scan upload to the driver: the error toast with the
 * "mobile-app-bottom-error-toast-instead-of-banner" toggle on, the footer error
 * banner with it off.
 *
 * `reported`: the failure came from one of the file-upload thunks, which
 * already reported it to Sentry and raised the toast. Pass false for failures
 * outside them (camera, file system).
 */
const useShowUploadError = () => {
  const dispatch = useAppDispatch();
  const toastInsteadOfBanner = useFeature(
    "mobile-app-bottom-error-toast-instead-of-banner"
  );

  return (err: unknown, { reported }: { reported: boolean }) => {
    const messageKey = reported ? null : handleActionError(err);
    if (!toastInsteadOfBanner) {
      dispatch(connectionActions.errorReturned());
    } else if (messageKey) {
      dispatch(errorToastShown(messageKey));
    }
  };
};

export default useShowUploadError;
